import angular from 'angular';
import { CallAncillariesPageService } from '../../../../../../features/services/services/services/ib-call-ancillaries-service';
import { AncillariesTransformer } from '../../../../../../features/transformers/ib-web-ancillaries-transformer';
import { TierTypeEnum, TierTypeFormattedEnum, TypesBidEnum } from '../../../enums';

const componentOptions = {
    bindings: {
        model: '='
    },
    controllerAs: 'bidsSelectCtrl',
    templateUrl: [
        '$rootScope',
        function ($rootScope) {
            return $rootScope.routes.templates + 'ib-bids-selection-view.html';
        }
    ]
};

const componentInfo = {
    module: 'ib-upgrading-bids-selection-module',
    selector: 'ibBidsSelection',
    inject: [
        '$scope',
        'CurrencyService',
        'AncillariesTransformer',
        'localStorageService',
        'ModalServiceAncillaries',
        'CallAncillariesPageService',
        'AncillariesService',
        'CommonsModalService',
        'DatalayerUtilsService',
        'CommonsConstants',
        '$rootScope',
        'CommonsAncillariesService'
    ],
    required: ['']
};

export class ibBidsSelection implements ng.IController {
    aviosAvailable: boolean = false;
    bidsAmount = 0;
    bidsAvailable: boolean = false;
    currency: CommonsCurrencyModel.CurrencyResponse;
    customerInfo: any;
    formData: any = {};
    havePendingAncillaries: boolean;
    headerBasketModel: any;
    isCheckedTooltip: boolean = false;
    isLoading = true;
    isSelectedFree: boolean = false;
    isUpgradingStandard: boolean;
    numberCouponsAvailable: number = 0;
    numberCouponsWalip: number = 0;
    numberFreeSelected: number = 0;
    payButton = false;
    segmentNumber: number = 0;
    segmentSelected: number = -1;
    segmentSelectedBids: number = -1;
    showCancel: boolean = true;
    tierIB: string;
    totalAvios: any;
    totalAviosAmount: number = 0;
    totalCouponsByTier: number = 0;
    totalPrice: any;
    totalPriceAmount = 0;
    updateWaitingListOK: boolean = false;
    usedCoupons: number = 0;
    waitingListActivate: boolean = false;
    waitingListPurchased: boolean = false;
    waitingListUpgUsed: number = 0;
    model: any;
    typesBid = TypesBidEnum;
    isDisabledButtonContinue: boolean = true;

    constructor (
        private $scope: angular.IScope,
        private CurrencyService: CurrencyService,
        private AncillariesTransformer: AncillariesTransformer,
        private localStorageService: angular.local.storage.ILocalStorageService,
        private ModalServiceAncillaries: any,
        private CallAncillariesPageService: CallAncillariesPageService,
        private AncillariesService: any,
        private CommonsModalService: CommonsModalService,
        private DatalayerUtilsService: any,
        private CommonsConstants: CommonsConstantsType,
        private $rootScope: CommonsRootScope,
        private CommonsAncillariesService: CommonsAncillariesService
    ) {
        this.$scope.$on('openCancelOffer', this.openCancelOffer);
        this.$scope.$on('updateTotalPrice', this.updateTotalPrice);
        this.$scope.$on('refreshBidsModalScreen', this.refreshBidsModalScreen);
    }

    $onInit (): void {
        this.currency = this.localStorageService.get('currency');
        this.havePendingAncillaries = this.headerBasketModel?.headerModel?.shoppingBasket.total.original > 0;
        this.headerBasketModel = this.localStorageService.get('headerModel');
        let category: string = '';
        this.model.tlf = '900 212 252 / +34 91 329 88 14';
        const upgradingBidsInfo: any = this.localStorageService.get('upgradingBidsInfo');
        const waitingListInfo: any = this.localStorageService.get('waitingListInfo');
        const breakdownInfo: any = this.localStorageService.get('breakdownInfo');
        if (breakdownInfo && breakdownInfo.freeItems.length > 0 && breakdownInfo.freeItems[0].type === 'UPGRADING_WAITING_LIST') {
            this.checkedPurchasedWaitingList(breakdownInfo);
        }
        const confirmationDigitalInfo: any = this.localStorageService.get('confirmationDigitalInfo');
        this.customerInfo = this.localStorageService.get('customerData');
        if (this.customerInfo && this.customerInfo.generalInfo && this.customerInfo.generalInfo.category) {
            category = this.customerInfo.generalInfo.category;
        }
        this.localStorageService.set('sessionUpgradingBidsInfo', upgradingBidsInfo);
        this.isUpgradingStandard = upgradingBidsInfo.subtype === 'STANDARD';
        this.segmentNumber = upgradingBidsInfo?.ancillariesTrips.length;
        this.numberCouponsAvailable = upgradingBidsInfo?.freeUpgradesAvailable || 0;
        this.tierIB = this.checkAndFormatIberiaMemberLevel(confirmationDigitalInfo?.UserLevel || category);
        [this.usedCoupons, this.totalCouponsByTier] = this.setTotalAndUsedCoupons(confirmationDigitalInfo?.UserLevel || category);
        const flowApp = this.$rootScope.flowName;
        if (flowApp === 'MMB') {
            /* INIT DELETE GA4 MIGRATION */
            this.DatalayerUtilsService.updateDatalayerWithQuadrigam(
                this.CommonsConstants.QUADRIGAM.MODAL_BIDS,
                null,
                this.localStorageService.get('userLogged')
            );
            /* FINISH DELETE GA4 MIGRATION*/
            this.DatalayerUtilsService.updateDigitalDataWithQuadrigam(
                this.CommonsConstants.QUADRIGAM.MODAL_BIDS,
                null,
                this.localStorageService.get('userLogged')
            );
        }
        if (upgradingBidsInfo.priceFrom > 0 || upgradingBidsInfo.bidsAvailable) {
            this.bidsAvailable = true;
        }
        if (upgradingBidsInfo.bidsAvailable || upgradingBidsInfo.aviosBidAvailable || upgradingBidsInfo.waitingListAvailable) {
            this.payButton = true;
            if (this.localStorageService.get('blockedContinueSection')) {
                this.payButton = false;
            }
            if (upgradingBidsInfo.bidsAvailable && !this.model.bidsBlocked && !this.model.bidsOpen) {
                this.payButton = false;
            }
            if (this.model.bidsClosed) {
                this.payButton = false;
            }
        }
        if (upgradingBidsInfo.aviosBidAvailable) {
            this.aviosAvailable = true;
        }
        if (upgradingBidsInfo.waitingListAvailable) {
            this.waitingListActivate = true;
        }
        const totalAmountBids: any = this.localStorageService.get('totalAmountBids');
        if (totalAmountBids > 0) {
            this.totalPrice = 0;
            this.payButton = false;
        }
        this.totalPrice = this.CurrencyService.formatPrice(this.currency, this.totalPrice, true, false, false);
        this.totalAvios = this.CurrencyService.formatAvios(this.currency?.groupingSeparator, this.totalAviosAmount);
        this.isLoading = false;
    }

    /**
     * Open modal for show conditions of rate
     * @param {String} currentCabin
     * @param {Object} segment
     * @param {String} indexOffer
     */
    openConditions = (segment, indexOffer, currentCabin): void => {
        if (segment === 'waitingList') {
            this.ModalServiceAncillaries.showWaitingListInfoModal({}, true, null);
        } else {
            this.ModalServiceAncillaries.openUpgradingKnowMore({ segmentInfo: segment, offerSelected: indexOffer, currentCabin: currentCabin });
        }
    };

    openHowItWorks (): void {
        this.ModalServiceAncillaries.openUpgradingBidHowItWorksModal({});
    }

    /**
     *  Update the total price of bids to pay
     */
    private updateTotalPrice = (_evt, slider): void => {
        const idBid = slider.options.id.split('_');
        let segmentCabinsPrice = 0, compareAmount = [];
        this.totalPriceAmount = 0;
        this.segmentSelectedBids = -1;
        this.payButton = false;
        this.model.ancillariesTrips.forEach((trip, index) => {
            compareAmount = [];
            if (trip.cabins && trip.cabins.length > 0) {
                for (const cabin of trip.cabins) {
                    let offerBid = 0;
                    if (cabin.AmountBid === undefined) {
                        cabin.AmountBid = 0;
                    }
                    if (idBid[2] === cabin.cabinType && idBid[1] === trip.id) {
                        cabin.bidOffer = this.CurrencyService.formatPrice(this.currency, slider.value, true, false, false);
                        cabin.AmountBid = slider.value;
                        cabin.AmountPassengersBid = this.CurrencyService.formatPrice(this.currency, slider.value * this.model.ancillariesTrips[0].passengers, true, false, false);
                        this.segmentSelectedBids = index;
                        offerBid = cabin.AmountBid;
                    }
                    if (cabin.currentBidByPax && !cabin.AmountBid) {
                        offerBid = cabin.currentBidByPax;
                        cabin.AmountBid = offerBid;
                        cabin.AmountPassengersBid = this.CurrencyService.formatPrice(this.currency, offerBid * this.model.ancillariesTrips[0].passengers, true, false, false);
                        trip.hasBid = true;
                    } else if (cabin.AmountBid > cabin.currentBidByPax || (offerBid === 0 && cabin.AmountBid > 0)) {
                        offerBid = cabin.AmountBid;
                        trip.hasBid = true;
                    }
                    compareAmount.push(offerBid);
                }
                compareAmount = compareAmount.sort((a, b) => {
                    return b - a;
                });
                segmentCabinsPrice = compareAmount[0];
                if (segmentCabinsPrice > 0) {
                    this.totalPriceAmount += segmentCabinsPrice * this.model.ancillariesTrips[0].passengers;
                    // this.selectedOnlyOneUpgrading(this.BIDS, this.segmentSelectedBids, cabinAux, slider);
                }
                if (compareAmount[1] > 0 && segmentCabinsPrice > compareAmount[1]) {
                    trip.cabins[0].greyStyle = false;
                    trip.cabins[1].greyStyle = true;
                }
            }
            if (trip.cabinsFinished) {
                for (const cabinFinished of trip.cabinsFinished) {
                    if (cabinFinished.status === 'BLOCKED') {
                        trip.hasBid = true;
                        cabinFinished.totalCurrentBid = this.CurrencyService.formatPrice(this.currency, cabinFinished.amountPax * this.model.ancillariesTrips[0].passengers, true, false, false);
                    }
                }
            }
            if (trip.cabins) {
                for (const cabin of trip.cabins) {
                    if (cabin.AmountBid !== cabin.currentBidByPax) {
                        this.payButton = true;
                    }
                }
            }
        });
        if (this.totalPriceAmount > 0 && this.payButton) {
            this.payButton = true;
            this.isDisabledButtonContinue = false;
        } else {
            this.payButton = false;
            this.isDisabledButtonContinue = true;
        }
        this.totalPrice = this.CurrencyService.formatPrice(this.currency, this.totalPriceAmount, true, false, false);
        this.localStorageService.set('sessionUpgradingBidsInfo', this.model);
    };

    /**
     *  Inform user with a modal that we are deleting pending ancillaries and
     * delete them and go to payments screen to pay all the bids and/or upgrades that users do.
     */
    goPaymentsBid = () => {
        if (this.localStorageService.get('waitingListUpdateInfo')) {
            this.updateWaitingList(this.localStorageService.get('waitingListUpdateInfo'));
        } else {
            return new Promise((resolve, reject) => {
                if (this.havePendingAncillaries) {
                    this.CommonsModalService.showGenericComponentModal(this.getDeleteAncillariesModal(), true).result.then(
                        () => {
                            this.isLoading = true;
                            this.deleteAllAncillaries();
                        },
                        () => {}
                    );
                } else {
                    this.setAviosModel();
                }
            });
        }
    };

    private deleteAllAncillaries = () => {
        return new Promise((resolve, reject) => {
            this.CommonsAncillariesService.deleteAllAncillaries().then(
                (data) => {
                    if (data.failedToDelete && data.failedToDelete.length > 0) {
                        this.showError({
                            message: data.failedToDelete[0].error.description,
                            internalErrorCode: data.failedToDelete[0].error.code
                        });
                        reject(data);
                    } else {
                        this.localStorageService.remove('flightAviosInfo');
                        this.setAviosModel();
                    }
                },
                (error) => {
                    reject(error);
                }
            );
        });
    };

    private setAviosModel = () => {
        this.AncillariesService.upgradeBidsUpdate(this.model).then(
            () => {
                this.model?.waitingListAvailable ? this.model.waitingListAvailable = false : null;
                this.localStorageService.set('upgBidPutMade', this.model);
                this.localStorageService.set('upgAviosPutMade', this.model);
                //this.localStorageService.remove('addToCart'); -> comentado porque falla el delete de la basket despues del flujo de pujas
                this.$scope.$emit('toPmtView');
            },
            (error) => {
                this.isLoading = false;
                if (error.code === 'BID_MGMT_ERR_0011') {
                    this.CommonsModalService.showGenericComponentModal({
                        title: 'UPGRADING_BIDS_ERROR_TIME_TITLE',
                        subtitle: '',
                        body: 'UPGRADING_BIDS_ERROR_TIME_BODY',
                        accept: 'MODAL_ACCEPT_BUTTON',
                        cancel: 'MODAL_CANCEL_BUTTON',
                        showCancelButton: true,
                        showCloseButton: true
                    }, true);
                } else {
                    this.CommonsModalService.showGenericError(error, null, null).result.then(angular.noop, angular.noop);
                }
            }
        );
    };
    /**
     *  Show a modal to inform user about delete pending ancillaries.
     */
    private getDeleteAncillariesModal = (): CommonsModalsModels.GenericComponentModalModel => {
        return {
            title: 'MMB_UPGRADING_AVIOS_DELETE_ANC_MODAL_TITLE',
            subtitle: 'MMB_UPGRADING_AVIOS_DELETE_ANC_MODAL_SUBTITLE',
            body: 'MMB_UPGRADING_AVIOS_DELETE_ANC_MODAL_BODY',
            accept: 'MODAL_ACCEPT_BUTTON',
            cancel: 'MODAL_CANCEL_BUTTON',
            showCancelButton: true,
            showCloseButton: true
        };
    };

    /**
     * Open modal for cancel bid offer
     */
    openCancelOffer = (event, segmentBidInfo, cabinType): void => {
        this.CommonsModalService.showGenericModal(true, 'ib-upg-bids-cancel-offer-modal.html', segmentBidInfo, null).result.then(
            () => {
                this.isLoading = true;
                this.localStorageService.set('RechargeBookingInfo', true);
                this.AncillariesService.cancelBidOffer(segmentBidInfo, cabinType);
                if(this.localStorageService.get('userLogged')) {
                    this.localStorageService.remove('upgradingBidsSlicesInfoResult');
                    this.$rootScope.$broadcast('closeBidModal');
                }
                this.payButton = false;
            },
            () => {
                angular.noop;
            }
        );
    };

    private refreshBidsModalScreen = (): void => {
        let transformData;
        const bookingInfo = this.localStorageService.get('bookingInfo');
        this.CallAncillariesPageService.getUpgradingBidAncillarie().then(
            (response) => {
                transformData = this.AncillariesTransformer.generateInfoManageMyBooking(response, bookingInfo);
                this.model.ancillariesTrips = transformData.bidsUpgradingInfo.ancillariesTrips;
                if (transformData.bidsUpgradingInfo.totalAmountBidsFormated === '') {
                    this.totalPrice = this.CurrencyService.formatPrice(this.currency, 0, true, false, false);
                } else {
                    this.totalPrice = transformData.bidsUpgradingInfo.totalAmountBidsFormated;
                }
                this.isLoading = false;
                this.localStorageService.set('sessionUpgradingBidsInfo', transformData.bidsUpgradingInfo);
                this.localStorageService.set('totalAmountBids', this.totalPrice);
            },
            (error) => {
                this.CommonsModalService.showGenericError(error, null, null).result.then(angular.noop, angular.noop);
            }
        );
    };

    /**
     * Select the last option depending on what you have selected, depending on the type in the same segment.
     *
     * @param type the type (avios, free or bids)
     * @param segmentNumber the number of segment
     */
    selectedOnlyOneUpgrading = (type: string, segmentNumber: number, cabinSelected: any, slider: any): boolean => {
        /*if(segmentNumber !== -1) {
            if((this.totalAviosAmount > 0 || this.isSelectedFree) && type === this.BIDS) {
                if(this.model.ancillariesTrips[segmentNumber]?.cabins?.find(cabin => cabin.selectedOffers === TypesBidEnum.STANDARD|| cabin.selectedOffers === TypesBidEnum.FREE)) {
                    this.$rootScope.$broadcast('resetBidsByUpgAvios', slider);
                    this.totalAviosAmount = 0;
                    cabinSelected.bidOffer = 0;
                    cabinSelected.AmountBid = 0;
                    return false;
                }
            }
            if(this.totalPriceAmount > 0 && (type === TypesBidEnum.FREE|| type === TypesBidEnum.STANDARD)) {
                if(this.model.ancillariesTrips[segmentNumber]?.cabins?.find(cabin => cabin.AmountBid > 0)) {
                    cabinSelected.selectedOffers = false;
                    return false;
                }
            }
        }*/
        return true;
    };

    /**
     * Update avios offer selected
     *
     * @param subType the sub type
     * @param cabin the cabin
     * @param bidSegmentIndex the segment index
     * @param cabinIndex the cabin index
     */
    updateAviosOffer = (subType, cabin, bidSegmentIndex, cabinIndex): void => {
        if (this.selectedOnlyOneUpgrading(subType, bidSegmentIndex, cabin, null)) {
            this.isSelectedFree = false;
            this.numberFreeSelected = 0;
            this.totalAviosAmount = 0;
            this.model.ancillariesTrips[bidSegmentIndex].cabins.forEach((cabin, index) => {
                if (cabin.selectedOffers === TypesBidEnum.STANDARD && index !== cabinIndex) {
                    cabin.selectedOffers = false;
                }
                if (cabin.selectedOffers === TypesBidEnum.STANDARD && index === cabinIndex) {
                    //this.isCheckedTooltip = false;
                    this.segmentSelected = bidSegmentIndex;
                }
                if (cabin.selectedOffers === TypesBidEnum.FREE && index === cabinIndex) {
                    //this.isCheckedTooltip = false;
                    this.segmentSelected = bidSegmentIndex;
                }
                if (cabin.selectedOffers === TypesBidEnum.FREE && index !== cabinIndex) {
                    cabin.selectedOffers = false;
                }
                //if (cabin.selectedOffers === TypesBidEnum.WAITING_LIST) {
                // this.cancelOffer(cabin, bidSegmentIndex, index);
                // }
                if (this.isCheckedTooltip) {
                    this.isCheckedTooltip = false;
                    this.localStorageService.remove('waitingListUpdateInfo');
                    for (let i = 0; i < this.model.ancillariesTrips.length; i++) {
                        for (let j = 0; j < this.model.ancillariesTrips[i].cabins.length; j++) {
                            this.model.ancillariesTrips[i].cabins[j].checked = false;
                            this.model.ancillariesTrips[i].cabins[j].offered = false;
                        }
                    }
                }
            });
            this.model.ancillariesTrips.forEach((trip, _index) => {
                if (_index !== this.segmentSelected && this.segmentSelected !== -1) {
                    trip.cabins?.forEach((cabin, _index) => {
                        // TODO DESCOMENTAR ESTOS IF Y ELIMINAR EL OTRO CUANDO EL BACK PUEDA RECIBIR DOS UPDGRADING EN UNA RESERVA
                        // if (cabin.selectedOffers === TypesBidEnum.STANDARD&& subType === TypesBidEnum.STANDARD) {
                        //     cabin.selectedOffers = false;
                        // }
                        // if (cabin.selectedOffers === TypesBidEnum.FREE&& subType === TypesBidEnum.FREE) {
                        //     cabin.selectedOffers = false;
                        // }
                        if (cabin.selectedOffers === TypesBidEnum.STANDARD || cabin.selectedOffers === TypesBidEnum.FREE || cabin.selectedOffers === TypesBidEnum.WAITING_LIST) {
                            cabin.selectedOffers = false;
                        }
                    });
                }
                this.getSelectedFreeAndTotalAvios(trip);
            });
            this.totalAvios = this.CurrencyService.formatAvios(this.currency?.groupingSeparator, this.totalAviosAmount);
            this.localStorageService.set('numberFreeUpgrade', this.numberFreeSelected);
            this.localStorageService.set('totalAviosAmount', this.totalAviosAmount);
            this.localStorageService.set('sessionUpgradingBidsInfo', this.model);
        }
        this.handleIsDisabledButtonContinue();
    };

    /**
     * Check if there is a cabin with selected offers equal to free and total avios
     *
     * @param trip the trip
     */
    private getSelectedFreeAndTotalAvios = (trip): void => {
        trip.cabins?.forEach((cabin, _index) => {
            if (cabin.selectedOffers === TypesBidEnum.FREE) {
                this.isSelectedFree = true;
                this.numberFreeSelected += cabin.free;
            }
            if (cabin.selectedOffers === TypesBidEnum.STANDARD) {
                this.totalAviosAmount += cabin.avios;
            }
        });
    };

    /**
     * Cancel offer by cabin
     *
     * @param cabin the cabin
     */
    cancelOffer = (cabin, bidSegmentIndex, cabinIndex): void => {
        let i: number, j: number;
        if (this.isCheckedTooltip) {
            for (i = 0; i < this.model.ancillariesTrips.length; i++) {
                for (j = 0; j < this.model.ancillariesTrips[i].cabins.length; j++) {
                    if (bidSegmentIndex === i && cabinIndex === j && this.model.ancillariesTrips[bidSegmentIndex].cabins[cabinIndex].checked) {
                        this.model.ancillariesTrips[bidSegmentIndex].cabins[cabinIndex].checked = false;
                        this.model.ancillariesTrips[bidSegmentIndex].cabins[cabinIndex].offered = false;
                        this.isCheckedTooltip = false;
                        this.totalAviosAmount = 0;
                        this.numberFreeSelected = 0;
                        this.totalAvios = this.CurrencyService.formatAvios('.', this.totalAviosAmount);
                        this.isDisabledButtonContinue = true;
                    }
                }
            }
        }
        if (cabin.selectedOffers === TypesBidEnum.STANDARD) {
            this.localStorageService.remove('aviosprice');
            this.totalAviosAmount -= cabin.avios;
            this.totalAvios = this.CurrencyService.formatAvios(this.currency?.groupingSeparator, this.totalAviosAmount);
        }
        if (cabin.selectedOffers === TypesBidEnum.FREE) {
            this.isSelectedFree = false;
            this.numberFreeSelected -= cabin.free;
            this.numberFreeSelected === 0
                ? this.localStorageService.remove('numberFreeUpgrade')
                : this.localStorageService.set('numberFreeUpgrade', this.numberFreeSelected);
        }
        cabin.selectedOffers = false;
    };

    private handleIsDisabledButtonContinue = (): void => {
        let isDisabled = true;
        const waitingListPurchased = this.localStorageService.get('waitingListPurchased');
        if (this.isCheckedTooltip && !waitingListPurchased) {
            isDisabled = false;
        } else if (!this.model.freePossibility) {
            if (!(this.totalPriceAmount === 0 && this.totalAviosAmount === 0)) {
                isDisabled = false;
                this.payButton = true;
            }
        } else {
            this.model.ancillariesTrips.forEach((trip, bidSegment) => {
                trip.cabins?.forEach((cabin) => {
                    if (cabin.selectedOffers === TypesBidEnum.STANDARD || cabin.selectedOffers === TypesBidEnum.FREE) {
                        isDisabled = false;
                        this.payButton = true;
                    }
                });
            });
            isDisabled = isDisabled && this.totalPriceAmount === 0;
        }
        this.isDisabledButtonContinue = isDisabled;
    };

    private checkAndFormatIberiaMemberLevel = (userLevel) => {
        let iberiaMemberLevelFormatted: string;
        switch (userLevel) {
                case TierTypeEnum.CLASICA:
                    iberiaMemberLevelFormatted = TierTypeFormattedEnum.CLASICA;
                    break;
                case TierTypeEnum.PLATA:
                    iberiaMemberLevelFormatted = TierTypeFormattedEnum.PLATA;
                    break;
                case TierTypeEnum.ORO:
                    iberiaMemberLevelFormatted = TierTypeFormattedEnum.ORO;
                    break;
                case TierTypeEnum.PLATINO:
                    iberiaMemberLevelFormatted = TierTypeFormattedEnum.PLATINO;
                    break;
                case TierTypeEnum.PLATINO_PRIME:
                    iberiaMemberLevelFormatted = TierTypeFormattedEnum.PLATINO_PRIME;
                    break;
                case TierTypeEnum.INFINITA:
                    iberiaMemberLevelFormatted = TierTypeFormattedEnum.INFINITA;
                    break;
                case TierTypeEnum.INFINITA_PRIME:
                    iberiaMemberLevelFormatted = TierTypeFormattedEnum.INFINITA_PRIME;
                    break;
                default:
                    iberiaMemberLevelFormatted = TierTypeFormattedEnum.CLASICA;
        }
        return iberiaMemberLevelFormatted;
    };

    /*
     * Set total coupons depending on iberia plus user level and set total used coupons before by the user
     */
    private setTotalAndUsedCoupons = (userLevel) => {
        if (userLevel === TierTypeEnum.PLATINO) {
            this.totalCouponsByTier = Math.min(this.numberCouponsAvailable, 2);
            this.usedCoupons = 2 - this.totalCouponsByTier;
        }
        if ([TierTypeEnum.PLATINO_PRIME, TierTypeEnum.INFINITA_PRIME, TierTypeEnum.INFINITA].includes(userLevel)) {
            const couponsAvailable = Math.min(this.numberCouponsAvailable, 4);
            this.totalCouponsByTier = 4;
            this.usedCoupons = 4 - couponsAvailable;
        }
        return [this.usedCoupons, this.totalCouponsByTier];
    };
    /*
     * Show modal error in case something went wrong.
     */
    private showError = (error) => {
        this.ModalServiceAncillaries.isNotWaiting();
        this.ModalServiceAncillaries.setErrorMessage(error.message);
        this.ModalServiceAncillaries.setErrorCode(error.internalErrorCode);
        this.ModalServiceAncillaries.isError(error, null, null);
    };

    selectWaitingList = (cabin: any, bidSegmentIndex: any, cabinIndex: any): void => {
        let i: number, j: number;
        const updateInfo: any = [
            {
                type: 'UPGRADING_WAITING_LIST',
                segments: [
                    {
                        id: cabin.id,
                        cabin: {
                            type: cabin.cabinType
                        }
                    }
                ]
            }
        ];
        this.localStorageService.set('waitingListUpdateInfo', updateInfo);
        this.localStorageService.remove('numberFreeUpgrade');
        this.isCheckedTooltip = true;
        this.numberFreeSelected = 0;
        this.isSelectedFree = false;
        for (i = 0; i < this.model.ancillariesTrips.length; i++) {
            for (j = 0; j < this.model.ancillariesTrips[i].cabins.length; j++) {
                if (bidSegmentIndex === i && cabinIndex === j) {
                    this.model.ancillariesTrips[bidSegmentIndex].cabins[cabinIndex].checked = true;
                    this.model.ancillariesTrips[bidSegmentIndex].cabins[cabinIndex].offered = true;
                    this.numberCouponsWalip = this.model.ancillariesTrips[bidSegmentIndex].cabins[cabinIndex].numToUse;
                } else {
                    if (this.model.ancillariesTrips[i].cabins[j].selectedOffers) {
                        delete this.model.ancillariesTrips[i].cabins[j].selectedOffers;
                    }
                    this.model.ancillariesTrips[i].cabins[j].checked = false;
                    this.model.ancillariesTrips[i].cabins[j].offered = false;
                }
            }
        }
        this.isDisabledButtonContinue = false;
    };

    private updateWaitingList = (cabin: any): void => {
        let i: number, j: number;
        const updateInfo = this.localStorageService.get('waitingListUpdateInfo');
        this.isLoading = true;
        this.CommonsAncillariesService.updateAncillaries(updateInfo).then(
            (data) => {
                this.isDisabledButtonContinue = true;
                this.localStorageService.remove('waitingListUpdateInfo');
                this.localStorageService.set('waitingListPurchased', true);
                this.waitingListPurchased = true;
                this.isLoading = false;
                this.showCancel = false;
                this.isCheckedTooltip = false;
                this.totalAviosAmount = 0;
                this.numberFreeSelected = 0;
                this.totalAvios = this.CurrencyService.formatAvios('.', this.totalAviosAmount);
                for (i = 0; i < this.model.ancillariesTrips.length; i++) {
                    for (j = 0; j < this.model.ancillariesTrips[i].cabins.length; j++) {
                        if (this.model.ancillariesTrips[i].cabins[j].checked) {
                            this.model.ancillariesTrips[i].cabins[j].purchased = true;
                            this.model.ancillariesTrips[i].cabins[j].checked = false;
                        } else {
                            this.model.ancillariesTrips[i].cabins[j].disabled = true;
                        }
                    }
                }
            },
            (error) => {
                this.isLoading = false;
                this.ModalServiceAncillaries.showGenericError(error).result.then(angular.noop, angular.noop);
            }
        );
    };

    private checkedPurchasedWaitingList = (breakdownInfo: any): void => {
        let i: number, j: number;
        for (i = 0; i < this.model.ancillariesTrips.length; i++) {
            if (this.model.ancillariesTrips[i].id === breakdownInfo.freeItems[0].segments[0].id) {
                for (j = 0; j < this.model.ancillariesTrips[i].cabins.length; j++) {
                    if (this.model.ancillariesTrips[i].cabins[j].cabinType === breakdownInfo.freeItems[0].segments[0].cabin.type) {
                        this.model.ancillariesTrips[i].cabins.splice(j, 1);
                    }
                }
            }
        }
    };
}

try {
    const mod = angular.module(componentInfo.module);
    ibBidsSelection.$inject = componentInfo.inject;
    mod.component(componentInfo.selector, angular.extend(componentOptions, { controller: ibBidsSelection }));
} catch (error) {
    const mod = angular.module(componentInfo.module, componentInfo.required);
    ibBidsSelection.$inject = componentInfo.inject;
    mod.component(componentInfo.selector, angular.extend(componentOptions, { controller: ibBidsSelection }));
}
